module.exports = __webpack_public_path__ + "static/img/title.347a32b.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/team/title.png
// module id = 1axv
// module chunks = 7